import { Link } from 'react-router-dom';
import { Button, Card, Grid, Typography, Icon } from "@material-ui/core";
import { ArrowForward } from '@material-ui/icons';
import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../common/theme";

import {menuItems, getItemsByCategory} from "../../common/menuConstants";
import MenuCategory from "./menuCategory";
// import React from "react";

const useStyles = makeStyles({
  root: {
    color: 'black',
    backgroundColor: 'white',
    // border: '1px solid red',
  },
  camera: {
    float: 'right',
    paddingTop: '10px',
    '&:hover': {
      cursor: 'pointer'
    },
  }
});

const MenuContainer = ({ selectItem }) => {
  const classes = useStyles();

  const handleCameraClick = (item) => {
    selectItem(item);
  }

  return (
    <Card className={classes.root}>
      <Grid container justify='space-evenly'>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Typography variant="body1" style={{ paddingTop: '20px' }}>We are currently offering dine-in and take-out orders. To order call: <a href="tel: 574-971-8674">(574) 971-8674</a></Typography>
          <a
            href="https://castanedatacos-imgs.s3.us-east-2.amazonaws.com/Castaneda_Tacos_PDF.pdf"
            target="_blank"
            rel="noreferrer"
          >
          <Button variant="outlined" color="secondary" style={{ marginTop: '15px' }}>View/Download menu PDF</Button>
          </a>
        </Grid>
        <MenuCategory categoryId={1} size="lg" handleCameraClick={handleCameraClick}/>
        <Grid item xs={11}><Typography className='meat-choices'>
          <b>*Meat Choices:</b> Asada<span>(Beef Skirt Steak)</span>, Bistek<span>(Steak)</span>,
          Pollo<span>(Chicken)</span>, Al Pastor<span>(Marinated Pork)</span>, Chorizo<span>(Mexican Sausage)</span>,
          Carnitas<span>(Shredded Pork)</span>, Camarón<span>(Shrimp)</span>, Lengua<span>(Beef Tongue)</span>, Pescado<span>(Fish)</span>, Rajas con queso<span>Veggies with cheese</span>.
        </Typography></Grid>
        <MenuCategory categoryId={8} size="lg" handleCameraClick={handleCameraClick}/>
        <MenuCategory categoryId={2} size="sm" handleCameraClick={handleCameraClick}/>
        <MenuCategory categoryId={3} size="lg" handleCameraClick={handleCameraClick}/>
        <MenuCategory categoryId={7} size="lg" handleCameraClick={handleCameraClick}/>
        <MenuCategory categoryId={4} size="sm" handleCameraClick={handleCameraClick}/>
        <Grid item xs={10}>
          <div style={{ float: 'right' }}>
            <Link to="/menu/beverages">
              <Button
                variant="outlined"
                color="secondary"
                endIcon={<ArrowForward />}
              >
                View our full beverages menu
              </Button>
            </Link>
          </div>
        </Grid>
        <MenuCategory categoryId={5} size="sm" handleCameraClick={handleCameraClick}/>
        <MenuCategory categoryId={6} size="lg" handleCameraClick={handleCameraClick}/>

      </Grid>
  </Card>
  );
};

export default MenuContainer;
